import _ from 'lodash'
import { celsiusToFahrenheit, fahrenheitToCelsius } from 'temperature'

export default (value) =>
  `${fahrenheitToCelsius(_.round(celsiusToFahrenheit(parseFloat(value))))}`
